import { useEffect, useState } from "react";
import styles from "./updatePasswordRequest.module.css";
import { NavLink, useNavigate } from "react-router-dom";
import * as v from "valibot";
import { useForm } from "react-hook-form";
import { valibotResolver } from "@hookform/resolvers/valibot";

import { useUpdatePasswordMutation } from "../../../features/api/user/userApi";
import { Input } from "../../common/input/Input";

const schema = v.pipe(
  v.object({
    password: v.pipe(
      v.string(),
      v.regex(/[A-Z]/, "At least one capital letter is required"), // At least one uppercase letter
      v.regex(/[a-z]/, "At least one small letter is required"), // At least one lowercase letter
      v.regex(/[0-9]/, "At least one number is required"), // At least one number
      v.regex(
        /[!@#$%^&*(),.?":{}|<>+-]/,
        "At least one special character is required"
      ), // At least one special character
      v.minLength(8, "Password has to be at least 8 character long")
    ),
    passwordConfirmation: v.pipe(v.string()),
  }),
  v.forward(
    v.partialCheck(
      [["password"], ["passwordConfirmation"]],
      (input) => input.password === input.passwordConfirmation,
      "Passwords don't match" // Ensure passwords match"
    ),
    ["passwordConfirmation"]
  )
);

export const UpdatePasswordRequest = () => {
  const [token, setToken] = useState(null);
  const [serverErr, setServerErr] = useState(false);
  const [tokenExpired, setTokenExpired] = useState(false);
  const [tokenMissing, setTokenMissing] = useState(false);
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm({
    defaultValues: {
      password: "",
      passwordConfirmation: "",
    },
    resolver: valibotResolver(schema),
  });
  const navigate = useNavigate();

  const [updatePassword, { isLoading, isSuccess }] =
    useUpdatePasswordMutation();

  const onSubmit = async (userInfo) => {
    if (!token) {
      tokenMissingErr();
    } else {
      try {
        let data = { password: userInfo.password };
        await updatePassword({ data, token }).unwrap();
        setTimeout(() => {
          navigate("/");
        }, 5000);
      } catch (err) {
        if (err?.data?.errorCode === 400) {
          tokenExpiredErr();
        } else {
          serverError();
        }
      }
    }
  };
  const tokenMissingErr = () => {
    setTokenMissing(true);
    setTimeout(() => {
      setTokenMissing(false);
      navigate("/");
    }, 5000);
  };
  const tokenExpiredErr = () => {
    setTokenExpired(true);
    setTimeout(() => {
      setTokenExpired(false);
      navigate("/");
    }, 3000);
  };
  const serverError = () => {
    setTokenExpired(true);
    setTimeout(() => {
      setServerErr(false);
      navigate("/");
    }, 3000);
  };
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const tokenParam = params.get("token");
    setToken(tokenParam);
    if (!tokenParam) tokenMissingErr();
  }, []);
  return (
    <div className={styles.update_password_container}>
      <form
        className={styles.update_password_form}
        onSubmit={handleSubmit(onSubmit)}
      >
        <section>
          <Input
            label="Password"
            field="password"
            type="password"
            register={register}
            error={errors.password}
            color="#ffffff"
          />{" "}
          <Input
            label="Confirmation"
            field="passwordConfirmation"
            type="password"
            register={register}
            error={errors.passwordConfirmation}
            color="#ffffff"
          />
        </section>
        <section className={styles.submit_btn_info}>
          <button type="submit" disabled={isLoading}>
            {isLoading ? "In progess..." : "Update"}
          </button>
          {tokenExpired && (
            <p className={`${styles.update_info} ${styles.err_msg}`}>
              The link is expired or invalid
            </p>
          )}

          {serverErr && (
            <p className={`${styles.update_info} ${styles.err_msg}`}>
              An error occured, please try again
            </p>
          )}
          {tokenMissing && (
            <p className={`${styles.update_info} ${styles.err_msg}`}>
              Invalid request
            </p>
          )}
          {isSuccess && (
            <p className={`${styles.update_info} ${styles.success_msg}`}>
              Password updated successfully
            </p>
          )}
        </section>
        <ul className={styles.redirect_btn_group}>
          <li>
            <NavLink to="/">Login</NavLink>
          </li>
        </ul>
      </form>
    </div>
  );
};
